<app-dialog-header *ngIf="this.dataDialog.isDialog" label="Operacions Massives" i18n-label></app-dialog-header>

<app-toolbar>
    <app-tool-button text="Actualizar" i18n-text (click)="this.refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
    <app-tool-button text="Ejecutar operación" i18n-text (click)="this.ejecutarOperacionMassivo();" color="has-color-green" icon="fa-check-double"></app-tool-button>
</app-toolbar>

<app-pedefinides-table #predefinidesTable (ejecutarOperacionEvent)="this.ejecutarOperacion($event)"></app-pedefinides-table>

